import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from 'src/app/lib/services/auth.service';
import { environment } from 'src/environments/environment.prod';
import { MainFacade } from '../main.facade';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {
  public season$: Observable<any>|undefined;
  isMuted:boolean=true;
  private destroy$ = new Subject();

  constructor(private mainfacade:MainFacade, private router:Router, private auth:AuthService) { }

  ngOnInit(): void {
    this.setObservables();
    this.pullDiscordAuth();
    let video = document.getElementById('vid') as HTMLVideoElement;
    video.play();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  playMusic(){
    let video = document.getElementById('vid') as HTMLVideoElement;
    this.isMuted = !this.isMuted;
    video.muted=this.isMuted;
  }

  setObservables() {
    this.season$ = this.mainfacade.season$;
    
  }

  route(path){
    this.router.navigateByUrl(path)
  }

  pullDiscordAuth(){
    let check = window.location.href.indexOf('code');

    if(check > -1){
      let base = window.location.href.split('code=')[1];
      let baseCode = base.split('&state=');
      var code = base.split('&state=')[0];
      var state = baseCode[1].split('#')[0];

      var stateValidated = this.auth.decryptToken(state);
      if(stateValidated){
        sessionStorage.setItem('code', code);
        window.location.href = environment.prod+'/#/profile';
   
      }
    }

  }

  

}
